module.exports = __webpack_public_path__ + "img/require-icon-4.dbe7977d.png";